export default function createSizes()
{
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2),
    onResizeCallbacks: [],
  }

  window.addEventListener('resize', () =>
  {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    sizes.pixelRatio = Math.min(window.devicePixelRatio, 2)

    sizes.onResizeCallbacks.forEach((fn) => fn())
  })

  sizes.onResize = (fn) =>
  {
    sizes.onResizeCallbacks.push(fn)
  }

  return sizes
}
